// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_ff-0";